export default __webpack_public_path__ + "images/team-mvp-star-f5370.svg";